<template>
    <div class="perfect-scrollbar-off guest-layout">
        <vue-progress-bar></vue-progress-bar>
        <div class="container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Empty',
        data () {
            return {
            }
        },

        mounted () {
        },

        methods: {
        }
    }
</script>

<style scoped lang="scss">
</style>
